import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function GenericIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d="M44 72L30 56L54 52L64 72Z" fill={c.p300} />
      <path d="M116 72L130 56L106 52L96 72Z" fill={c.p300} />
      <rect x="44" y="70" width="72" height="58" rx="8" fill={c.p500} />
      <path d="M44 84V76a6 6 0 0 1 6-6h60a6 6 0 0 1 6 6v8z" fill={c.p700} />
      <rect x="68" y="98" width="24" height="14" rx="4" fill={c.a300} />
    </Frame>
  );
}
